import {
  FDIcon, FDTitleText, FDStack,
} from '@facet-wealth/design';
import React from 'react';
import PropTypes from 'prop-types';
import { dataAttrs } from 'Helpers/Testing';

export const SignedAtComponent = ({ value }) => (
  <FDStack alignItems={'center'} spacing={1}>
    <FDIcon icon={'checkCircleIcon'} color={'textSecondary'} />
    <FDTitleText
      value={value}
      color={'textSecondary'}
      {...dataAttrs('endorser agreement page signed message')}
    />
  </FDStack>
);

SignedAtComponent.propTypes = {
  value: PropTypes.string.isRequired,
};
